var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1-Wallet/Payment_01",
    transform: "translate(-1249.000000, -524.000000)",
    fill: "#8F9BA9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1235.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-Copy-3",
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(4.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.56,2.44 C14.64,3.88 16,6.28 16,9 C16,13.42 12.42,17 8,17 C3.58,17 0,13.42 0,9 C0,6.28 1.36,3.88 3.44,2.44 L3.44,2.44 L4.88,3.88 C3.16,4.94 2,6.83 2,9 C2,12.31 4.69,15 8,15 C11.31,15 14,12.31 14,9 C14,6.83 12.84,4.94 11.11,3.89 L11.11,3.89 Z M9,0 L9,10 L7,10 L7,0 L9,0 Z",
    id: "Logout"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.d7eb15a729f3967aa383c9ebf2ca749b.svg";
export { ForwardRef as ReactComponent };